import { render } from "./PatientPayLater.vue?vue&type=template&id=76dbc41a&scoped=true"
import script from "./PatientPayLater.vue?vue&type=script&lang=js"
export * from "./PatientPayLater.vue?vue&type=script&lang=js"

import "./PatientPayLater.vue?vue&type=style&index=0&id=76dbc41a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76dbc41a"]])

export default __exports__